"use strict";
var controller = function($scope, $uibModalInstance, $q, $http, $timeout, deleteParams) {
  $scope.delete = function() {
    var params = {};
    $http.delete('/api/work/' + $scope.id + '.json', {params: params}).success(function(data, status, headers, config) {
      $scope.loading = true;
      $scope.response = data;
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
      window.location = '/work?page=1';
    });
  };
  $scope.revert = function() {
    window.location = '/work/revert/' + $scope.id;
  };
  $scope.confirm = function() {
    window.location = '/work/confirm/' + $scope.id;
  };
  var init = function() {
    $scope.id = deleteParams.id;
    $scope.descriptions = deleteParams.descriptions;
  }();
};
module.exports = controller;
